import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const DiabeticWoundPage = () => (
  <>
    <Header />
    <main className="py-12 bg-swastik-lightEarth/40 min-h-screen">
      <div className="container mx-auto px-4 max-w-3xl">
        <h1 className="text-3xl md:text-4xl font-bold text-swastik-blue mb-6">Natural Herbal Treatment for Diabetic Wound</h1>
        <section className="mb-8">
          <p>Diabetic wounds are slow-healing sores that can occur in people with diabetes, often due to poor blood circulation and nerve damage. Natural therapies can help promote healing, reduce infection risk, and support overall skin health.</p>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Causes</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Poor blood circulation</li>
            <li>Nerve damage (neuropathy)</li>
            <li>High blood sugar levels</li>
            <li>Immune system dysfunction</li>
            <li>Infections</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Symptoms</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Slow-healing sores or ulcers</li>
            <li>Redness or swelling</li>
            <li>Pain or tenderness</li>
            <li>Foul-smelling discharge</li>
            <li>Fever (if infected)</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Our Herbal Approach</h2>
          <p>We use antimicrobial herbs, healing oils, and gentle therapies to promote wound healing, reduce infection risk, and support overall skin health. Each plan is tailored to your needs for safe, effective care.</p>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Benefits of Herbal Treatment</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Promotes natural healing</li>
            <li>Reduces infection risk</li>
            <li>No harsh side effects</li>
            <li>Personalized, gentle care</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Lifestyle Recommendations</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Maintain good blood sugar control</li>
            <li>Keep the wound clean and dry</li>
            <li>Wear appropriate footwear</li>
            <li>Regular check-ups with healthcare providers</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Frequently Asked Questions</h2>
          <div className="mb-4">
            <strong>Q1: Can herbal treatment heal diabetic wounds?</strong>
            <p>A: Yes, our approach can support healing and reduce infection risk, especially with early intervention.</p>
          </div>
          <div className="mb-4">
            <strong>Q2: Is this safe for sensitive skin?</strong>
            <p>A: Yes, our remedies are gentle and soothing.</p>
          </div>
          <div className="mb-4">
            <strong>Q3: How soon will I see improvement?</strong>
            <p>A: Many patients notice relief within a few weeks.</p>
          </div>
        </section>
        <section className="mb-8">
          <div className="bg-swastik-blue/10 p-6 rounded-lg text-center">
            <h3 className="text-xl font-semibold mb-2">Find gentle relief—book your herbal diabetic wound care session today!</h3>
            <a href="/contact" className="inline-block mt-4 px-6 py-2 bg-swastik-blue text-white rounded hover:bg-swastik-blue/90 transition">Book Consultation</a>
          </div>
        </section>
      </div>
    </main>
    <Footer />
  </>
);

export default DiabeticWoundPage; 